module.exports = __webpack_public_path__ + "img/Hillcrest Hall, 1941.6887950d.jpg";